export enum ForceUnitsEnum {
    newton = "NEWTON",
    //...
}
